module.exports = __webpack_public_path__ + "img/1579206756.e9189e75.jpg";